var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityCube2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cube_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.027 7.209l-4.072-1.453-3.982 1.422 4.072 1.453z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.443l-5-1.785v6.816l5 1.785z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.883l-5-1.787v6.879l5 1.785z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.072 4.694l-4.072-1.453-4.072 1.453 4.072 1.455z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.975l5 1.785v-6.816l-5-1.785z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.381l-5-1.785v6.879l5 1.785z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26.26l5-1.785v-6.879l-5 1.785z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.955 8.631l4.072-1.453-3.982-1.422-4.072 1.453z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.26l5-1.785v-6.816l-5 1.785z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.016 9.693l3.984 1.422 3.984-1.422-3.984-1.422z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.096l-5 1.787v6.877l5-1.785z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.76l5-1.785v-6.816l-5 1.785z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityCube2);
export default __webpack_public_path__ + "static/media/unity_cube_2.f0cabb746e0aa6753825d5cf02c909cd.svg";
export { ForwardRef as ReactComponent };